import { Component, OnInit, Input } from '@angular/core';

import { FormGroup, FormControl, Validators } from '@angular/forms';
import { RadioModel } from './radio-model';
import { UiFactory } from '../../core/ui/ui-factory';

@Component({
  selector: 'pg-radio-factory, grit-radio-factory',
  templateUrl: './pg-radio-factory.component.html',
  styleUrls: ['./pg-radio-factory.component.scss'],
})
export class PgRadioFactoryComponent extends UiFactory {
  @Input() model: any;

  @Input() parentFormGroup: FormGroup;

  get radioModel(): RadioModel {
    return this.model;
  }

  ngOnInit() {
    super.ngOnInit();
    if (!this.parentFormGroup) {
      throw new Error(
        'parentFormGroup is a required input for pg-checkbox-factory'
      );
    }

    let control = this.parentFormGroup.get(this.radioModel.formControlName);
    if (!control) {
      this.parentFormGroup.addControl(
        this.radioModel.formControlName,
        new FormControl()
      );
      control = this.parentFormGroup.get(this.radioModel.formControlName);
    }
  }
}
